module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "userInfo",
    attrs: {
      "lg12": ""
    }
  }, [_vm._l((_vm.globalModalParams.history), function(history) {
    return _c('div', {
      staticClass: "historyBox"
    }, [_c('table', {
      attrs: {
        "width": "100%"
      }
    }, [_c('tr', [_c('td', [_c('strong', [_vm._v("NEW STATUS:")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(history.statusTo))])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("PREVIOUS STATUS:")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(history.statusFrom))])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("DATE CHANGED:")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(history.date))])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("CHANGED BY:")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(history.fullname))])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("COMMENTS:")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.fncCheckComment(history.comment)))])])])])
  }), _vm._v(" "), (Object.keys(_vm.globalModalParams.history).length === 0) ? _c('p', [_vm._v("There are no status changes recorded for this entry.")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-4 pb-4 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")])], 1)])], 1)], 1)
},staticRenderFns: []}